import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeGoogleLogin, takeReturnPath } from '../lib/googleAuth';

/* Lands on /real-or-fake/auth/google/callback after Google redirects back.
   Exchanges the code for a real PocketBase session, then hands over to the router — useAuth
   sees pb.authStore change and runs the roster gate from there. */

export default function GoogleCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  // StrictMode double-invokes effects in dev; exchanging the same code twice fails the second
  // time and would show a spurious error on an otherwise successful sign-in.
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    void (async () => {
      const result = await completeGoogleLogin();
      if (!result.ok) {
        setError(result.error || 'Sign-in failed.');
        return;
      }
      navigate(takeReturnPath(), { replace: true });
    })();
  }, [navigate]);

  if (error) {
    return (
      <div className="auth-wrap">
        <div className="auth-card">
          <div>
            <div className="wordmark">Adorian</div>
            <div className="product">Real or Fake</div>
          </div>
          <div className="notice bad">{error}</div>
          <button className="btn primary" onClick={() => navigate('/', { replace: true })}>
            Back to Sign In
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="state-block">
      <div className="big">Signing you in</div>
      <div className="sub">Finishing up with Google…</div>
    </div>
  );
}
